// extracted by mini-css-extract-plugin
module.exports = {"SpinnerContainer":"Action_SpinnerContainer__1kPzx","FormContainer":"Action_FormContainer__1_9Ha","text":"Action_text__YN5vd"};